export default __webpack_public_path__ + "static/banner_devops-f36fbef65cf6ef0a83a0e9af707ff4ff.webp";